<template>
  <div class="agenda-viewer">
    <v-card :loading="loading" tile style="height:auto !important" >
      <v-card-title v-if="showTitle">
        <!-- <v-btn
          color="error" 
          style="margin-right: 10px"
          :to="{ name: 'dashboard' }"
          elevation="2"
        >
          <v-icon>mdi-arrow-left</v-icon> Indietro
        </v-btn> -->
        <v-spacer></v-spacer>Agenda<v-spacer></v-spacer></v-card-title
      >
      <v-card-text v-if="days.length == 0">
        Nessun evento da mostrare
      </v-card-text>
      <v-card-text v-if="days.length > 0">
        <div v-for="day in days" :key="day.text" class="day">
          <h2 class="day-text">{{ day.text }}</h2>
          <v-divider></v-divider>
          <div class="day-hours">
            <v-expansion-panels>
              <div
                class="agenda-row"
                v-for="hour in day.hours"
                :key="hour.hour"
              >
                <div v-if="hour.event == undefined " >
                  {{ moment(hour.hour).format("HH:mm") }}
                </div>
                <div v-if="hour.event != undefined">
                  <!-- {{moment(hour.event.inizio).format("HH:mm")}} -->
                  <span v-if="hour.event.giornoIntero"> Giornata intera </span>
                  <span v-if="!hour.event.giornoIntero">
                    {{ moment(hour.event.inizio).format("HH:mm") }} -
                    {{ moment(hour.event.fine).format("HH:mm") }}
                  </span>
                   <v-btn
                   v-if="isMobile  || showMobileVersion"
                   outlined
                   tile
                   :style="
                        'display:block;text-align: left; border:1px solid;height:auto; width:100% !important;' +
                        (hour.event.tipo==EventType.Intervento?hour.event.color:'#000') +
                        ';' +
                        'color:' +
                        (hour.event.tipo==EventType.Intervento?hour.event.color:'#000') +
                        ';'
                      "
                      :key="hour.event.idIntervento"
                      @click="event_Click(hour.event)">
                       
                      <div  
              >
                        <span style="font-size: 18px; display: inline-block" v-if="hour.event.cliente">
                          {{ hour.event.cliente.descrizione }}</span
                        ><br>
                         <span>{{ hour.event.descrizione }}</span>
                      </div>
                   </v-btn>
                  <v-expansion-panel
                    @change="expansionPanels_Change(hour, day)"
                     
                  v-if="!isMobile  && !showMobileVersion"
                  >
                    <!-- <v-btn class="elevation-2 text-white event"   style="position: relative; margin-left: 50px" :color="ev.color" outlined>{{ ev.cliente.descrizione }}</v-btn> -->
                    <v-expansion-panel-header
                      :style="
                        'text-align: left; border:1px solid ' +
                        (hour.event.tipo==EventType.Intervento?hour.event.color:'#000') +
                        ';' +
                        'color:' +
                        (hour.event.tipo==EventType.Intervento?hour.event.color:'#000')  + 
                        ';'
                      "
                      :key="hour.event.idIntervento"
                      dense
                    >
                      <div   v-if="!isMobile  && !showMobileVersion ">
                        <span style="font-size: 18px; display: inline-block"  v-if="hour.event.cliente">
                          {{ hour.event.cliente.descrizione }} - </span
                        > 
                        <span> {{ hour.event.descrizione }}</span>
                      </div> 
                     
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <EventInfoModal :evento="hour.event"></EventInfoModal>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <!-- {{moment(hour.event.fine).format("HH:mm")}} -->
                </div>
              </div>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
    </v-card>

     <v-dialog id="event-info-dialog" 
      hide-overlay
      fullscreen
      class="black--text grey lighten-2"
      transition="dialog-bottom-transition"
      v-model="showEventDetailsModal" max-width="600px">
      <!-- <v-card>
        <v-card-title> Dati evento </v-card-title>
        <v-card-text>
          <p>Data:{{ moment(this.event).format("DD/MM/YYYY") }}</p>
          <p>Giornata intera:{{ this.event.giornoIntero ? "SI" : "NO" }}</p>
          <p v-if="!this.event.giornoIntero">
            Ora:{{ moment(this.event).format("DD/MM/YYYY") }}
          </p>
        </v-card-text>
      </v-card> -->

      <v-card tile id="event-info-modal-card "> 
<v-toolbar
          
          color="white lighten-2 black--text"
          elevation="2"
        >
         <v-divider ></v-divider>
         <v-spacer></v-spacer>
        <!-- <v-spacer></v-spacer> -->
               <!-- <v-divider class="grey"></v-divider> -->
          <v-toolbar-title v-if="event!=null">  {{event.descrizione}}  </v-toolbar-title>
          
         <v-spacer></v-spacer>
           <v-divider ></v-divider>
            <!-- <v-spacer></v-spacer> -->
          <v-toolbar-items>
            
            <v-btn 
              text
              class="black--text  "
              icon
              @click="showEventDetailsModal = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      <EventInfoModal v-bind:evento="event" elevation :hideBoxShadow="Boolean(true)"  :hideEventDescription="Boolean(true)"  ref="eventModal"> </EventInfoModal>
  
      </v-card>
      <SelectDialog ref="selectNewEventOwner"> </SelectDialog>
      <SelectDialog ref="selectAbsenceReason"> </SelectDialog>
    </v-dialog>
    <!-- <div class="ma-12">
      <v-timeline>
        <v-timeline-item v-for="(event, i) in events" :key="i" left>
          <span>
            <h2 class="font-weight-medium">
              {{ moment(event.inizio).format("DD/MM/YYYY") }}
            </h2></span
          >
          <v-card class="elevation-2">
            <v-card-title class="headline">
              <v-divider></v-divider>
              <h5 class="font-weight-medium">
                {{ moment(event.inizio).format("HH:MM:SS") }} -
              </h5>

              <h5 class="font-weight-medium">
                {{ moment(event.fine).format("HH:MM:SS") }}
              </h5>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
              {{ ev.descrizione }}
                  <h3>Indirizzo:</h3>
                  <h3>Commessa:</h3>
                  <h3>Note:</h3>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div> -->
  </div>
</template>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import EventInfoModal from "../../components/Planner/EventInfoModal";
import EventType from "../../settings/EventType"
import moment from "moment";
import SessionHelper from "../../utils/SessionHelper";
export default {
  props:{
    showTitle:{default:true,type:Boolean},
    showMobileVersion:{default:false,type:Boolean}
  },
  components: { EventInfoModal },
  data: () => ({
    moment: moment,
    EventType:EventType,
    event:null,
    showEventDetailsModal:false,
    isMobile:false,
    days: [],
    events: [],
    loading: false,
  }),
  created() {
    this.checkIfIsMobile();
    var t = this;
    this.loadEvents((data) => {
      data=data.sort((e1,e2) =>  moment(e1.inizio).isBefore(e2.inizio));
      for (let i = 0; i < data.length; i++) {
        let ev = data[i];
        let fdate = moment(ev.inizio).format("DD MMM yyyy");

        let day = t.days.find((d) => d.text == fdate);
        if (day == undefined) {
          day = { text: fdate, date: ev.inizio, events: [], hours: [] };
          t.days.push(day);
        }
        day.events.push(ev);
      }
      let lastEv = null;
      // let nullEvCount=0;
      // let tmphours=[]; //buffer che contiene le ore vuote
      for (let i = 0; i < t.days.length; i++) {
        let day = t.days[i];
        for (let h = 0; h < 24; h++) {
          let hour = ("" + h).padStart(2, "0") + ":00";

          let hourEvent = day.events.find(
            (e) =>
              moment(this.FloorHours(e.inizio)).format("HH:mm") <= hour &&
              moment(this.FloorHours(e.fine)).format("HH:mm") >= hour
          );
          if (lastEv != hourEvent && hourEvent != undefined) {
            // nullEvCount=0;
            lastEv = hourEvent;

            day.hours.push({
              hour: this.FloorHours(hourEvent.inizio),
              event: undefined,
            });
            day.hours.push({
              hour: hour,
              event: hourEvent,
            });

            day.hours.push({
              hour: this.RoundHours(hourEvent.fine),
              event: undefined,
            });
          } else if (hourEvent == undefined) {
            // nullEvCount++;
            // tmphours.push({
            //   hour: hour,
            //   event: undefined,
            // });
          }
        }
      }
    });
  },

  methods: {
    
    event_Click(event){
      this.event=event;
      this.showEventDetailsModal=true;
    },
  checkIfIsMobile() {
      this.isMobile= window.innerWidth < 600;
    },
    getFullAddress(address, city, province) {
      let fullAddress = ""; //address + " - " + city + " (" + province + ") ";
      if (address != null) fullAddress += address;
      if (city != null) fullAddress += " - " + city;
      if (province != null) fullAddress += " (" + province + ")";

      return fullAddress;
    },
    expansionPanels_Change(hour, day) {
      console.log("loading event...", hour.event.idIntervento);
      let t = this;
      this.loadEvent(hour.event.idIntervento, function (e) {
        console.log("event", e);
        hour.event = e;
      });
    },
    loadEvent(eventId, callback) {
      console.log("loading event", eventId);
      EasyPlanClient.Event.Find(this.$route.params.companyAlias, eventId)
        .then((res) => {
          this.event = res.data.data;

          console.log(this.event);
          this.event.risorse = [];
          //le risorse vengono gestite come risorse dai vari stepper coinvolti, quindi per eventi già esistenti, per far selezionare correttamente le checkbox, bisogna ricaricare le cose
          this.event.risorseIntervento.forEach((element) => {
            this.event.risorse.push(element.risorsa);
          });
          callback(this.event);
          // this.dialog = true;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    agendaRow_Change(e, a) {
      console.debug("e", e);
      console.debug("a", a);
    },
    RoundHours(date) {
      let d = new Date(date);
      console.log("d", d);
      let rounded = d.setMinutes(60);
      return rounded;
    },
    FloorHours(date) {
      let d = new Date(date);
      console.log("d", d);
      let rounded = d.setMinutes(0);
      return rounded;
    },
    AddHours(date, hours) {
      let d = new Date(date);
      console.log("d", d);
      let dedited = d.setHours(d.getHours() + hours);
      return dedited;
    },
    HasEvent(date, hour) {},
    loadEvents(callback = () => {}) {
      this.loading = true;
      EasyPlanClient.Event.FindByCompanyAliasDateFromTo(
        this.$route.params.companyAlias,
        new Date(),
        new Date().setDate(new Date().getDate() + 30),
        true
      )
        .then((res) => { 
          this.events = res.data.data.sort((e1,e2) => {
              console.debug("isBefore e1,e2",moment(e1.inizio).isBefore(e2.inizio));
              if(moment(e1.inizio).isBefore(e2.inizio))
                return 1;
              else if(moment(e1.inizio).isSame(e2.inizio))
              return 0;
              else return -1;
          } );
          callback(res.data.data);
          // callback(res.data.data);
          console.log("EVENTI",this.events);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style type="scss"> 
 
.mainPage[isMobile="false"] .day-hours , .mainPage:not([isMobile]) .day-hours  {
  margin: 20px 20px;
}
.mainPage[isMobile="true"] .day-hours   {
  margin: 5px 10px;
}
 .mainPage   .day {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px 20px;
  /* border: 1px solid #aaa; */
  box-shadow: 0px 0px 3px #999;
}
 
/* .mainPage[isMobile="true"] .day {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 2px 2px; 
  box-shadow: 0px 0px 3px #999;
} */
.agenda-row {
  display: block;
  border-bottom: 1px solid #eee;
  min-height: 22px;
  width: 100%;
}
 .agenda-viewer {
    overflow: hidden;
    overflow-y: scroll;
}
h2.day-text {
    margin-top: 15px;
}
</style>